<template>
  <div class="modal-disclaimer">
    <div :class="{ 'collapsed': isSnippet }" ref="disclaimer">
      <p>
        <span>The phone and/or email you provide here will replace the previously provided information.</span>
        <span>This information can be used to lookup your reservation.</span>
      </p>
      <p>
        By selecting the "Send" button below you agree to receive a confirmation and reminder notification. Message
        and data rates may apply.
      </p>
    </div>
    <button class="app-btn-image toggle" @click="toggleDisclaimer">
      <img v-if="isSnippet" src="@ridmv/web-themes/images/icons/caret-down-solid.svg" alt="">
      <img v-else src="@ridmv/web-themes/images/icons/caret-up-solid.svg" alt="">
    </button>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue';

// emitted events
const emit = defineEmits(['doDisclaimer']);

// State and Reactive Variables
const isSnippet = ref(true);

// Template Refs
const disclaimer = ref(null);

// Methods 
const toggleDisclaimer = async () => {
  isSnippet.value = !isSnippet.value;

  await nextTick();
  const cls = disclaimer.value.classList;
  if (!cls.contains('collapsed')) {
    cls.add('expanded');
  }

  emit('doDisclaimer', isSnippet.value);
};
</script>


<style lang="scss" scoped>
.modal-disclaimer {
  --whitespace: calc(var(--padding-horizontal) * 0.5);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 var(--whitespace) 0;
  margin: 0.5em calc(var(--whitespace) * -1) 1em calc(var(--whitespace) * -1);
  button.toggle {
    margin: 0 0 0 0.05em;
    padding: 0 0.5em 0.5em;
    min-width: var(--icon-dimension);
    height: min-content;
    img {
      width: 16px;
    }
  }
  p {
    color: var(--ri-blue);
    font-size: 0.9rem;
    padding: 0.1em 0 1em;
    @extend %font-sans-semibold;
    span:nth-child(2) {
      &::before {
        content: ' ';
      }
    }
  }
  .collapsed {
    height: 63px;
    overflow: hidden;
    p:first-child {
      span {
        &:first-child {
          &::after {
            content: '..';
          }
        }
        &:nth-child(2) {
          visibility: hidden;
        }
      }
    }
  }
  .expanded {
    animation: fadeIn;
    animation-duration: 2s;
    height: max-content;
  }
}
</style>
